import { makeAutoObservable, runInAction } from "mobx";
import { PRestaurantHours } from "../PRestaurantHours";
/**
 * Drives a restaurant-hours widget instance: fetches (or adopts SSR-provided)
 * hours for one restaurant and exposes the parsed {@link PRestaurantHours}
 * view-model. The "now"-dependent rendering is left to the component, which
 * ticks its own clock — this controller only owns the data.
 */
export class RestaurantHoursController {
    constructor(params) {
        var _a;
        this.state = { type: "Loading" };
        this.slug = params.slug;
        this.timeZone = params.timeZone;
        this.service = params.service;
        this.parser = params.parser;
        this.initialData = (_a = params.initialData) !== null && _a !== void 0 ? _a : null;
        makeAutoObservable(this);
    }
    get isLoading() {
        return this.state.type === "Loading";
    }
    get hasError() {
        return this.state.type === "Error";
    }
    get hours() {
        return this.state.type === "Loaded" ? this.state.hours : null;
    }
    async load() {
        if (this.initialData !== null) {
            this.store(this.initialData);
            return;
        }
        try {
            const response = await this.service.fetchHours(this.slug);
            this.store(response);
        }
        catch {
            runInAction(() => {
                this.state = { type: "Error" };
            });
        }
    }
    store(response) {
        const parsed = this.parser.parse(response, this.timeZone);
        runInAction(() => {
            this.state = { type: "Loaded", hours: new PRestaurantHours(parsed) };
        });
    }
}
